import Repository from '@/repositories/RepositoryFactory';
import ApiState from "../../enums/APISTATE";

const reports = Repository.get('reports');

export default ({
    namespaced: true,
    state: {
      reportForPeriodApiState: ApiState.INIT,
      replacementReportForPeriodApiState: ApiState.INIT,
      monthReportApiState: ApiState.INIT,
      monthReportForPeriodApiState: ApiState.INIT,
      monthReportGroupApiState: ApiState.INIT,
      reportForPeriod: [],
      replacementReportForPeriod: [],
      monthReport: [],
      monthReportForPeriod: [],
      monthReportGroup: [],
      yearlyReport: [],      
      yearlyReportApiState: ApiState.INIT,
      reportNotification: [],
      reportNotificationApiState: ApiState.INIT,
      generalReportForPeriodApiState: ApiState.INIT,
      generalReportForPeriod: [],
      driveReportForPeriod: [],
      driveReportForPeriodApiState: ApiState.INIT,
      timeOffForPeriod: [],
      timeOffForPeriodApiState: ApiState.INIT
    },
    mutations: {
      setReportForPeriodApiState: (state, apiState) => {
        state.reportForPeriodApiState = apiState;
      },
      setMonthReportGroupApiState(state, apiState) {
        state.monthReportGroupApiState = apiState;
      },
      setReplacementReportForPeriodApiState: (state, apiState) => {
        state.replacementReportForPeriodApiState = apiState;
      },
      setMonthReportForPeriodApiState: (state, apiState) => {
        state.monthReportForPeriodApiState = apiState;
      },
      setMonthReportApiState: (state, apiState) => {
        state.monthReportApiState = apiState;
      },
      setReportForPeriod(state, response) {
        const { data } = response;
        state.reportForPeriod = data;
        state.reportForPeriodApiState = ApiState.LOADED;
      },
      setReplacementReportForPeriod(state, response) {
        const { data } = response;
        state.replacementReportForPeriod = data;
        state.replacementReportForPeriodApiState = ApiState.LOADED;
      },
      setMonthReportForPeriod(state, response) {
        const { data } = response;
        state.monthReportForPeriod = data;
        state.monthReportForPeriodApiState = ApiState.LOADED;
      },
      setMonthReport(state, response) {
        const { data } = response;
        state.monthReport = data;
        state.monthReportApiState = ApiState.LOADED;
      },
      setMonthReportGroup(state, response) {
        const { data } = response;
        state.monthReportGroup = data;
        state.monthReportGroupApiState = ApiState.LOADED;
      },
      setYearlyReport(state, response){
        const { data } = response;
        state.yearlyReport = data;
        state.yearlyReportApiState = ApiState.LOADED;
      },
      setYearlyReportApiState: (state, apiState) => {
        state.yearlyReportApiState = apiState;
      },
      setReportNotification(state, response){
        const { data } = response;
        state.reportNotification = data;
        state.reportNotificationApiState = ApiState.LOADED;
      },
      setReportNotificationApiState: (state, apiState) => {
        state.reportNotificationApiState = apiState;
      },
      setGeneralReportForPeriod(state, response){
        const { data } = response;
        state.generalReportForPeriod = data;
        state.generalReportForPeriodApiState = ApiState.LOADED;
      },
      setGeneralReportForPeriodApiState: (state, apiState) => {
        state.generalReportForPeriodApiState = apiState;
      },
      setDriveReportForPeriod(state, response){
        const { data } = response;
        state.driveReportForPeriod = data;
        state.driveReportForPeriodApiState = ApiState.LOADED;
      },
      setAbsenceStatisticsForPeriod(state, response){
        const { data } = response;
        state.monthReportForPeriod = data;
        state.monthReportForPeriodApiState = ApiState.LOADED;
      },
      setDriveReportForPeriodApiState: (state, apiState) => {
        state.driveReportForPeriodApiState = apiState;
      },
      setTimeOffForPeriod(state, response){
        const { data } = response;
        state.timeOffForPeriod = data;
        state.timeOffForPeriodApiState = ApiState.LOADED;
      },
      setTimeOffForPeriodApiState: (state, apiState) => {
        state.timeOffForPeriodApiState = apiState;
      },
      initialized(state, { reportForPeriod, replacementReportForPeriod }) {
        state.reportForPeriod = reportForPeriod;
        state.replacementReportForPeriodApiState = replacementReportForPeriod;
      }
    },
    actions: {
      async getReportForPeriod({ commit }, dto) {
        commit('setReportForPeriodApiState', ApiState.LOADING);
        try {
          commit('setReportForPeriod', await reports.getReportForPeriod(dto.startDate, dto.endDate, dto.forGroup));
        }
        catch (error) {
          console.error(error);
          commit('setReportForPeriodApiState', ApiState.ERROR);
        }
      },
      async getReplacementReportForPeriod({ commit }, dto) {
        commit('setReplacementReportForPeriodApiState', ApiState.LOADING);
        try {
          commit('setReplacementReportForPeriod', await reports.getReplacementReportForPeriod(dto.startDate, dto.endDate, dto.forRegion));
        }
        catch (error) {
          console.error(error);
          commit('setReplacementReportForPeriodApiState', ApiState.ERROR);
        }
      },
      async getGeneralReportForPeriod({ commit }, dto) {
        commit('setGeneralReportForPeriodApiState', ApiState.LOADING);
        try {
          commit('setGeneralReportForPeriod', await reports.getGeneralReportForPeriod(dto.startDate, dto.endDate, dto.forGroup, dto.forRegion));
        }
        catch (error) {
          console.error(error);
          commit('setGeneralReportForPeriodApiState', ApiState.ERROR);
        }
      },
    
      async getAbsenceStatisticsForPeriod({ commit }, dto) {
        commit('setMonthReportForPeriodApiState', ApiState.LOADING);
        try {
          commit('setMonthReportForPeriod', await reports.getAbsenceStatisticsForPeriod(dto.startDate, dto.endDate, dto.forGroup, dto.forUser));
        }
        catch (error) {
          console.error(error);
          commit('setMonthReportForPeriodApiState', ApiState.ERROR);
        }
      },
      async exportAbsenceCsv({ commit }, dto) {
        const response = await reports.exportAbsenceCsv(dto.startDate, dto.endDate, dto.forGroup, dto.forUser);
        return response.data;
      },
      async getDriveReportForPeriod({ commit }, dto) {
        commit('setDriveReportForPeriodApiState', ApiState.LOADING);
        try {
          commit('setDriveReportForPeriod', await reports.getDriveReportForPeriod(dto.startDate, dto.endDate, dto.forGroup, dto.forUser));
        }
        catch (error) {
          console.error(error);
          commit('setDriveReportForPeriodApiState', ApiState.ERROR);
        }
      },
      async getTimeOffForPeriod({ commit }, dto) {
        commit('setTimeOffForPeriodApiState', ApiState.LOADING);
        try {
          commit('setTimeOffForPeriod', await reports.getTimeOffForPeriod(dto.startDate, dto.endDate, dto.forGroup, dto.forUser));
        }
        catch (error) {
          console.error(error);
          commit('setTimeOffForPeriodApiState', ApiState.ERROR);
        }
      },
      async getMonthReport({ commit }, dto) {
        commit('setMonthReportApiState', ApiState.LOADING);
        try {
          commit('setMonthReport', await reports.getMonthReport(dto.year, dto.month, dto.forUser));
        }
        catch (error) {
          console.error(error);
          commit('setMonthReportApiState', ApiState.ERROR);
        }
      },
      async approveAllMonthReport({ commit }, dto) {
        commit('setMonthReportApiState', ApiState.LOADING);
        try {
          commit('setMonthReport', await reports.approveAllMonthReport(dto.year, dto.month, dto.forUser));
        }
        catch (error) {
          console.error(error);
          commit('setMonthReportApiState', ApiState.ERROR);
        }
      },
      async approveMonthReport({ commit }, dto) {
        try {
          await reports.approveMonthReport(dto.date, dto.forUser);
        }
        catch (error) {
          console.error(error);
        }
      },
      async getMonthGroupReport({ commit }, dto) {
        commit('setMonthReportGroupApiState', ApiState.LOADING);
        try {
          commit('setMonthReportGroup', await reports.getMonthGroupReport(dto.year, dto.month, dto.forGroup, dto.forRegion));
        }
        catch (error) {
          console.error(error);
          commit('setMonthReportGroupApiState', ApiState.ERROR);
        }
      },
      async getYearlyReport({ commit }, dto) {
        commit('setYearlyReportApiState', ApiState.LOADING);
        try {
          console.log(await reports.getYearlyReport(dto.year, dto.forUser));
          commit('setYearlyReport', await reports.getYearlyReport(dto.year, dto.forUser));
        }
        catch (error) {
          console.error(error);
          commit('setYearlyReportApiState', ApiState.ERROR);
        }
      },
      async getReportNotification({ commit }, employeeId) {
        commit('setReportNotificationApiState', ApiState.LOADING);
        try {
          commit('setReportNotification', await reports.getReportNotification(employeeId));
        }
        catch (error) {
          console.error(error);
          commit('setReportNotificationApiState', ApiState.ERROR);
        }
      },
      async setGeneralReportForPeriod({commit}, generalReportForPeriod){
        const reports = {data: generalReportForPeriod}
        commit("setGeneralReportForPeriod", reports)
      },
      async setDriveReportForPeriod({commit}, driveStaticsForPeriod){
        const reports = {data: driveStaticsForPeriod};
        commit("setDriveReportForPeriod", reports);
      },
      async setAbsenceStatisticsForPeriod({commit}, absenceStatisticsForPeriod){
        const reports = {data: absenceStatisticsForPeriod};
        commit("setAbsenceStatisticsForPeriod", reports);
      },
      async setTimeOffForPeriod({commit}, timeOffForPeriod){
        const reports = {data: timeOffForPeriod};
        commit("setTimeOffForPeriod", reports);
      }
    },
    getters: {
      reportNotification(state) {
        return state.reportNotification;
      },
      reportForPeriodApiState(state) {
        return state.reportForPeriodApiState;
      },
      replacementReportForPeriodApiState(state) {
        return state.replacementReportForPeriodApiState;
      },
      monthReportApiState(state) {
        return state.monthReportApiState;
      },
      monthReportGroupApiState(state) {
        return state.monthReportGroupApiState;
      },
      monthReportForPeriodApiState(state) {
        return state.monthReportForPeriodApiState;
      },
      reportForPeriod(state) { 
        return state.reportForPeriod; 
      },
      replacementReportForPeriod(state) { 
        return state.replacementReportForPeriod; 
      },
      monthReport(state) { 
        return state.monthReport; 
      },
      monthReportGroup(state) { 
        return state.monthReportGroup; 
      },
      monthReportForPeriod(state) { 
        return state.monthReportForPeriod; 
      },
      yearlyReport(state) { 
        return state.yearlyReport; 
      },
      yearlyReportApiState(state) { 
        return state.yearlyReportApiState; 
      },
      generalReportForPeriod(state) { 
        return state.generalReportForPeriod; 
      },
      generalReportForPeriodApiState(state) { 
        return state.generalReportForPeriodApiState; 
      },
      driveReportForPeriod(state) { 
        return state.driveReportForPeriod; 
      },
      driveReportForPeriodApiState(state) { 
        return state.driveReportForPeriodApiState; 
      },
      timeOffForPeriod(state) { 
        return state.timeOffForPeriod; 
      },
      timeOffForPeriodApiState(state) { 
        return state.timeOffForPeriodApiState; 
      }
    }
  });